export const getSearchParameter = (key: string) => {
  const urlParams = new URLSearchParams(window.location.search);

  if (!urlParams.has(key)) return undefined;

  return urlParams.get(key);
};
